module.exports = __webpack_public_path__ + "img/char_002.dd4d0f72.png";